/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} True_Gold_Bat_HoldInputs */

const en_true_gold_bat_hold = /** @type {(inputs: True_Gold_Bat_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Results engine`)
};

const de_true_gold_bat_hold = /** @type {(inputs: True_Gold_Bat_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ergebnis-Engine`)
};

/**
* | output |
* | --- |
* | "Results engine" |
*
* @param {True_Gold_Bat_HoldInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const true_gold_bat_hold = /** @type {((inputs?: True_Gold_Bat_HoldInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<True_Gold_Bat_HoldInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_true_gold_bat_hold(inputs)
	return de_true_gold_bat_hold(inputs)
});